// extracted by mini-css-extract-plugin
export var articlelist = "articles_mini-module--articlelist--dId9c";
export var article__meta = "articles_mini-module--article__meta--2F73S";
export var article__tax = "articles_mini-module--article__tax--3Clb6";
export var listitem = "articles_mini-module--listitem--yfcA3";
export var featimg = "articles_mini-module--featimg--p41Ue";
export var article__title = "articles_mini-module--article__title--2Z3oN";
export var article__content = "articles_mini-module--article__content--XYL1R";
export var tableauthor = "articles_mini-module--tableauthor--BR3eX";